import {SongProps} from '../../components/song/song.types';

export const SETLIST: SongProps[] = [
	{
		index: 1,
		album: 'August Twelve',
		songName: 'The Universe Smiles upon',
		image: '/img/songs/song01.png',
		played: undefined,
		draggable: true,
	},
	{
		index: 2,
		album: 'Dern Kala',
		songName: 'The Universe Smiles upon',
		image: '/img/songs/song02.png',
		played: undefined,
		draggable: true,
	},
	{
		index: 3,
		album: 'The Infamous Bill',
		songName: 'The Infamous Bill',
		image: '/img/songs/song03.png',
		played: undefined,
		draggable: true,
	},
	{
		index: 4,
		album: 'Mr. White',
		songName: 'The Universe Smiles upon',
		image: '/img/songs/song04.png',
		played: undefined,
		draggable: true,
	},
	{
		index: 5,
		album: 'Balls and Pins',
		songName: 'The Universe Smiles upon',
		image: '/img/songs/song05.png',
		played: undefined,
		draggable: true,
	},
	{
		index: 6,
		album: 'Lady and Man',
		songName: 'Con Todo El Mundo',
		image: '/img/songs/song06.png',
		played: undefined,
		draggable: true,
	},
	{
		index: 7,
		album: 'ho We Won`t Forget',
		songName: 'Mordechai',
		image: '/img/songs/song07.png',
		played: undefined,
		draggable: true,
	},
];
